import * as types from './constants';

// Get Codes Products Scroll
export const getCodesProductsScrollRequest = data => (
  { type: types.GET_CODES_PRODUCTS_SCROLL_REQUEST, payload: data }
);

export const getCodesProductsScrollDone = data => (
  { type: types.GET_CODES_PRODUCTS_SCROLL_DONE, payload: data }
);

export const getCodesProductsScrollFailed = errors => (
  { type: types.GET_CODES_PRODUCTS_SCROLL_FAILED, payload: errors }
);

export const getCodesProductsScrollReset = () => (
  { type: types.GET_CODES_PRODUCTS_SCROLL_RESET }
);

// Optimistic operations
export const myCreatorsConnectedScrollOptimisticRemove = uuid => ({
  type: types.CODES_PRODUCTS_SCROLL_OPTIMISTIC_REMOVE,
  payload: uuid
});

export const myCreatorsConnectedScrollOptimisticAdd = userRow => ({
  type: types.CODES_PRODUCTS_SCROLL_OPTIMISTIC_ADD,
  payload: userRow
});

// Operations
export const toggleCodesProductsScroll = data => (
  { type: types.TOGGLE_CODES_PRODUCTS_SCROLL, payload: data }
);

export const toggleAllCodesProductsScroll = data => (
  { type: types.TOGGLE_ALL_CODES_PRODUCTS_SCROLL, payload: data }
);

export const setFilter = data => (
  { type: types.SET_CODES_PRODUCTS_SCROLL_FILTER, payload: data }
);

export const setAllFilters = data => (
  { type: types.SET_CODES_PRODUCTS_SCROLL_ALL_FILTERS, payload: data }
);

export const clearFilters = (filterToUpdate, mobile) => (
  { type: types.CLEAR_CODES_PRODUCTS_SCROLL_FILTERS, payload: { filterToUpdate, mobile } }
);

// `url` is the `next` URL of the last loaded page; the request effect picks it up to load that page.
export const codesProductsScrollSetPageUrl = url => (
  { type: types.CODES_PRODUCTS_SCROLL_SET_PAGE_URL, payload: url }
);